import axios from 'axios'

import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const { searchEngine } = config.endpoints

const deepSearch = data => axios({
  method: 'post',
  url: searchEngine.deepSearch,
  data: {
    ...data,
    strict: false,
    pageSize: 30
  },
  headers: getHeaders(true)
})

const searchPreview = data => axios({
  method: 'post',
  url: searchEngine.searchPreview,
  data,
  headers: getHeaders(true)
})

const searchSuggestion = data => axios({
  method: 'post',
  url: searchEngine.searchSuggestion,
  data,
  headers: getHeaders(true)
})

export default {
  deepSearch,
  searchPreview,
  searchSuggestion
}
